"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var constants_1 = require("../constants");

var selectors_1 = require("../selectors");

var errors_1 = require("../errors");

var DEFAULT_DEPTH = 1;

exports.createQueryString = function (tablesList, tableId) {
  var queryObjectConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var prevKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var table = selectors_1.tablesListSelectors.getTableById(tablesList, tableId);

  if (!table) {
    throw new errors_1.SDKError(errors_1.ERROR_CODES.TABLE_NOT_FOUND, errors_1.PACKAGES.UTILS, "Table with id ".concat(tableId, " not found"));
  }

  var fields = table.fields,
      tableName = table.name;
  var _queryObjectConfig$de = queryObjectConfig.deep,
      deep = _queryObjectConfig$de === void 0 ? DEFAULT_DEPTH : _queryObjectConfig$de,
      _queryObjectConfig$wi = queryObjectConfig.withMeta,
      withMeta = _queryObjectConfig$wi === void 0 ? true : _queryObjectConfig$wi,
      relationItemsCount = queryObjectConfig.relationItemsCount,
      includeColumns = queryObjectConfig.includeColumns,
      _queryObjectConfig$pe = queryObjectConfig.permissions,
      permissions = _queryObjectConfig$pe === void 0 ? {} : _queryObjectConfig$pe,
      filterFields = queryObjectConfig.filterFields;
  var queryObject = '';
  fields.filter(function (field) {
    var isMeta = selectors_1.tableFieldSelectors.isMetaField(field);
    var isRelation = selectors_1.tableFieldSelectors.isRelationField(field);
    var shouldIncludeField = withMeta ? true : !isMeta;

    if (isRelation) {
      var refTableName = selectors_1.tableFieldSelectors.getRelationTableName(field);
      var refTableAllowed = R.pathOr(true, ['data', refTableName, 'permission', 'read', 'allow'], permissions);
      shouldIncludeField = refTableAllowed && shouldIncludeField;
    } else {
      var fieldAllowed = R.pathOr(true, ['data', tableName, 'permission', 'read', 'fields', field.name], permissions);
      shouldIncludeField = fieldAllowed && shouldIncludeField;
    }

    if (filterFields) {
      shouldIncludeField = shouldIncludeField && filterFields(field);
    }

    return shouldIncludeField;
  }).forEach(function (field) {
    var fieldContent = field.name;
    var isRelation = selectors_1.tableFieldSelectors.isRelationField(field);
    var isMissingRelation = selectors_1.tableFieldSelectors.isMissingRelationField(field);
    var isOneWayRelationField = selectors_1.tableFieldSelectors.isOneWayRelationField(field);
    var isFile = selectors_1.tableFieldSelectors.isFileField(field);
    var isGeo = selectors_1.tableFieldSelectors.isGeoField(field);
    var isSmart = selectors_1.tableFieldSelectors.isSmartField(field);
    var isList = selectors_1.tableFieldSelectors.isListField(field);
    var refTableId = selectors_1.tableFieldSelectors.getRelationTableId(field);
    var refTable = selectors_1.tablesListSelectors.getTableById(tablesList, refTableId);
    var isSettingsRefTable = selectors_1.tableFieldSelectors.isSystemField(field) && selectors_1.tableFieldSelectors.getRelationTableName(field) === constants_1.SYSTEM_TABLES.SETTINGS;
    var isPermissionsRefTable = selectors_1.tableFieldSelectors.isSystemField(field) && selectors_1.tableFieldSelectors.getRelationTableName(field) === constants_1.SYSTEM_TABLES.PERMISSIONS;
    var currentKeyString = prevKey ? "".concat(prevKey, ".").concat(field.name) : field.name;
    var isNotEmptyRelation = false;

    if (isSettingsRefTable || isPermissionsRefTable) {
      fieldContent = "{\n          _description\n        }";
    } else if (isMissingRelation) {
      fieldContent = "{\n          table\n        }";
    } else if (isRelation || isOneWayRelationField) {
      if (deep <= 1 || !refTableId || !refTable) {
        fieldContent = "{\n              id\n              _description\n            }";
      } else {
        var includeAllrelationFields = R.contains(currentKeyString, includeColumns || []);
        var relationIncludeColumns = includeAllrelationFields ? null : includeColumns;
        var innerFields = exports.createQueryString(tablesList, refTableId, {
          deep: deep - 1,
          includeColumns: relationIncludeColumns,
          withMeta: withMeta
        }, currentKeyString);
        isNotEmptyRelation = !R.isEmpty(innerFields);
        fieldContent = "{\n            id\n            ".concat(innerFields, "\n            _description\n          }");
      }
    } else if (isFile) {
      fieldContent = "{\n          id\n          fileId\n          filename\n          downloadUrl\n          shareUrl\n          meta\n          public\n        }";
    } else if (isGeo) {
      fieldContent = "{\n          type\n          coordinates\n          bbox\n        }";
    } else if (isSmart) {
      fieldContent = "{".concat(field.fieldTypeAttributes.innerFields.reduce(function (accum, _ref) {
        var name = _ref.name;
        accum += "\n".concat(name);
        return accum;
      }, ''), "}");
    }

    if (isList && (isRelation || isFile) && fieldContent !== null) {
      fieldContent = "{\n          items ".concat(fieldContent, "\n          count\n        }");
    }

    var needsInclude = !!includeColumns ? R.contains(currentKeyString, includeColumns) : true;

    if (fieldContent !== null && (needsInclude || isNotEmptyRelation)) {
      if (!!relationItemsCount && isList && isRelation) {
        queryObject += "\n".concat(field.name, "(first: ").concat(relationItemsCount, ") ").concat(fieldContent);
      } else {
        queryObject += "\n".concat(field.name, " ").concat(fieldContent);
      }
    }
  });
  return queryObject;
};